import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store'
import { HiArrowLeft, HiCheck, HiEye, HiEyeSlash, HiLockClosed, HiShieldCheck } from 'react-icons/hi2'
import { Alert, Button, Card, Field, Input } from '../ui'

export default function Login() {
  const navigate = useNavigate()
  const { login, loading, error } = useAuthStore()
  const [form, setForm] = useState({ username: '', password: '' })
  const [totpCode, setTotpCode] = useState('')
  const [needsTotp, setNeedsTotp] = useState(false)
  const [showPass, setShowPass] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    const res = await login(form.username, form.password, needsTotp ? totpCode : null)
    if (res.success) {
      navigate('/')
    } else if (res.needsTotp) {
      setNeedsTotp(true)
    }
  }

  return (
    // Sahifa kirishi — faqat shaffoflik, siljish yo'q (DESIGN.md 7).
    // `ui-root` fon, shrift va scrollbar'ni kit tokenlaridan oladi.
    <div className="ui-root ui-center page-enter" style={{ minHeight: '100vh', padding: 'var(--ui-sp-24)' }}>
      {/* Yagona sokin bezak: chegara rangidagi bitta halqa. Ma'lumot tashimaydi,
          shuning uchun ekran o'quvchidan yashiriladi (DESIGN.md 1). */}
      <div aria-hidden="true" style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
        <div style={{
          position: 'absolute', top: '50%', left: '50%',
          width: 720, height: 720, marginTop: -360, marginLeft: -360,
          border: '1px solid var(--ui-border)', borderRadius: '50%',
        }} />
      </div>

      <div style={{ position: 'relative', width: '100%', maxWidth: 400 }}>
        {/* Logotip va nom */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--ui-sp-24)' }}>
          <svg
            width="48" height="48" viewBox="0 0 1024 1024"
            fill="var(--ui-text-1)"
            role="img" aria-label="Cyber Advice logotipi"
            style={{ margin: '0 auto var(--ui-sp-12)' }}
          >
            <path d="M512.61 766.47c-191.73 0-382.35 23.79-446.14-114.4-21.3-46.15 156.87 53.84 302.12 65.37C269.82 673.22 142.26 612.89 111 502.09 97.46 454 325 655.19 382.14 669.37c-42.61-38.46-223.06-198.32-168.49-294.18 25.18-44.22 184 242.27 184 242.27s-134.75-248.84-58.1-324.95c31-30.76 67.78 276.88 141.38 344.17 0 0-35.83-382.63 30-380.71s51.32 244.19 32 384.55C630 519.4 645.53 315.59 672.64 288.67s69.72 153.82-63.91 332.64c77.47-13.46 197.54-299.95 203.35-251.88 19 157.26-166.55 294.18-166.55 294.18 120.07-38.46 244-188.43 269.19-165.36s-112.33 186.51-292.43 225c211.1-1.92 338.27-127.59 337-84.6-3.78 125.01-254.95 127.82-446.68 127.82z" />
          </svg>
          <h1 style={{
            fontFamily: "'Balldoug', var(--ui-font)",
            fontSize: 'var(--ui-fs-xl)', fontWeight: 600,
            letterSpacing: '-.02em', color: 'var(--ui-text-1)',
          }}>
            Cyber Advice
          </h1>
          <p style={{ marginTop: 'var(--ui-sp-4)', fontSize: 'var(--ui-fs-xs)', color: 'var(--ui-text-3)' }}>
            Kiberjinoyatlarga qarshi kurashish boshqarmasi
          </p>
        </div>

        <Card
          title={needsTotp ? 'Ikki bosqichli tekshirish' : 'Tizimga kirish'}
          icon={needsTotp ? HiShieldCheck : HiLockClosed}
        >
          <form onSubmit={handleSubmit} className="ui-col ui-gap-16">
            {error && <Alert tone="danger">{error}</Alert>}

            {!needsTotp ? (
              <>
                <Field label="Foydalanuvchi nomi yoki Email" htmlFor="login-username">
                  <Input
                    id="login-username"
                    name="username"
                    type="text"
                    autoComplete="username"
                    placeholder="username yoki email"
                    value={form.username}
                    onChange={(e) => setForm({ ...form, username: e.target.value })}
                    required
                    autoFocus
                  />
                </Field>

                <Field label="Parol" htmlFor="login-password">
                  {/* Ko'rsatish tugmasi input ustida turadi, shuning uchun
                      o'ng to'ldirish tugma kengligiga ochib qo'yiladi. */}
                  <div className="ui-input-wrap">
                    <Input
                      id="login-password"
                      name="password"
                      type={showPass ? 'text' : 'password'}
                      autoComplete="current-password"
                      placeholder="••••••••••••"
                      value={form.password}
                      onChange={(e) => setForm({ ...form, password: e.target.value })}
                      required
                      style={{ paddingRight: 'var(--ui-sp-32)' }}
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconOnly
                      icon={showPass ? HiEyeSlash : HiEye}
                      aria-label={showPass ? 'Parolni yashirish' : "Parolni ko'rsatish"}
                      aria-pressed={showPass}
                      onClick={() => setShowPass(!showPass)}
                      style={{
                        position: 'absolute', right: 'var(--ui-sp-4)',
                        top: '50%', transform: 'translateY(-50%)',
                      }}
                    />
                  </div>
                </Field>
              </>
            ) : (
              <>
                <p style={{
                  fontSize: 'var(--ui-fs-sm)', color: 'var(--ui-text-2)',
                  textAlign: 'center', lineHeight: 1.6,
                }}>
                  Google Authenticator ilovasidagi 6 xonali kodni kiriting
                </p>

                <Field label="Bir martalik kod" htmlFor="login-totp">
                  {/* Raqamlar monoshriftda, keng oraliq bilan — kodni bir qarashda
                      o'qish uchun. Kenglik sakramasin deb tabular-nums (DESIGN.md 3). */}
                  <Input
                    id="login-totp"
                    name="totp"
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    className="ui-mono ui-nums"
                    placeholder="000000"
                    maxLength={6}
                    value={totpCode}
                    onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    autoFocus
                    style={{
                      height: 'var(--ui-sp-48)',
                      fontSize: 'var(--ui-fs-xl)', fontWeight: 600,
                      textAlign: 'center',
                      // oxirgi belgidan keyingi oraliqni qoplaydi — matn markazda qoladi
                      letterSpacing: '.24em', textIndent: '.24em',
                    }}
                  />
                </Field>
              </>
            )}

            <Button
              type="submit"
              variant="primary"
              loading={loading}
              icon={needsTotp ? HiCheck : undefined}
              style={{ width: '100%' }}
            >
              {loading ? 'Kirilmoqda...' : needsTotp ? 'Tasdiqlash' : 'Kirish'}
            </Button>

            {needsTotp && (
              <Button
                variant="ghost"
                size="sm"
                icon={HiArrowLeft}
                onClick={() => setNeedsTotp(false)}
                style={{ alignSelf: 'center' }}
              >
                Orqaga qaytish
              </Button>
            )}
          </form>
        </Card>

        <p style={{
          marginTop: 'var(--ui-sp-16)', textAlign: 'center',
          fontSize: 'var(--ui-fs-xs)', color: 'var(--ui-text-3)',
        }}>
          © 2026 Cyber Advice · Jizzax Viloyati
        </p>
      </div>
    </div>
  )
}
